import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate, search } from "../../../Common";
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { LoftAmendmentsReportSchema } from "../LoftAmendmentsReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import moment from 'moment';
import CssBaseline from '@material-ui/core/CssBaseline';
import xlsx from 'json-as-xlsx';
import { LoftAmendmentTableContent } from '../../../Common/Table/tableContent';
import _ from 'lodash';
import CardContent from '@material-ui/core/CardContent';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import '../Pages/tableFooter.css';
import MaterialTable from "material-table";

const screenCode = 'LOFTAMENDMENTSREPORT'



const useStyles = makeStyles(theme => ({
    root: {
      width: "100%",
      marginTop: theme.spacing(3),
      overflowX: "auto"
    },
    table: {
      minWidth: 700
    },
    card: {
        width: "100%"
    },
    succes: {
        backgroundColor: "#e8f5e9"
      }
  }));
  
export function LoftAmendmentsReport(props) {

    const classes = useStyles();
    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0",
        toDate: "",
        fromDate: ""

    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(LoftAmendmentsReportSchema).options({ allowUnknown: true });
    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [reportData, setReportData] = useState({
        routeWiseData : [],
        noOfDeductionBagCount:0,
        noOfLeafTypeCount:0,
        numberOfAmendedRoutes:0,
        totBagCount:0
    });
    const [isViewTable, setIsViewTable] = useState(true);
    const [densityTotal, setDensityTotal] = useState([]);
    const [fatTotal, setFatTotal] = useState([]);
    const [weightTotal, setWeightTotal] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const initialColumName = ["collectionPointName", "loftAmendedDate","registrationNumber", "tagNumber", "netAmount", "deductionTypeName","deductionValue","loftTotal","PreviousCollectionType","ChangedValue"];
    
    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        if(searchData.operationEntityID != 0){
        trackPromise(
            getCollectionPointsForDropDown()
        )}
    }, [searchData.operationEntityID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWLOFTAMENDMENTSREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            // operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, LoftAmendmentsReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
    }


    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    async function handleSearch(e) {
        const errorMessages = validate(schema, searchData)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return;

        let data = {
            factoryID: parseInt(searchData.operationEntityID),
            groupID: parseInt(searchData.groupID),
            collectionPointID: parseInt(searchData.collectionPointID),
            toDate: searchData.toDate,
            fromDate: searchData.fromDate
        }
        const loftData = await service.getLoftAmendmentReport(data);

        if (loftData != null || loftData != undefined) {
            setReportData(loftData);
            setIsViewTable(false)
        } else {
            setIsViewTable(true)
        }



    }


    return (
        <Fragment>
            <CssBaseline />
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Loft Amendments Report"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Factory *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Factory--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Collection point</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection point--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>

                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <TextField
                                        id="fromDate"
                                        label="From Date *"
                                        name="fromDate"
                                        type="date"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>

                                <div className="col-md pb-1">
                                    <TextField
                                        id="toDate"
                                        label="To Date *"
                                        name="toDate"
                                        type="date"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        disabled={validate(schema, searchData)}
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>
                            <div hidden={isViewTable}>
                                <Box minWidth={1050}>
                                    <MaterialTable
                                        title="Multiple Actions Preview"
                                        columns={[
                                            { title: 'Route Name', field: 'collectionPointName' },
                                            {
                                                title: 'Date', field: 'loftAmendedDate',
                                                render: rowData => rowData.loftAmendedDate.split('T')[0]
                  
                                              },
                                            { title: 'Reg Number', field: 'registrationNumber' },
                                            { title: 'Tag Number', field: 'tagNumber' },
                                            { title: 'Net Amount', field: 'netAmount' },
                                            { title: 'Deduction Type', field: 'deductionTypeName' },
                                            { title: 'Value', field: 'deductionValue' },
                                            { title: 'Loft Total', field: '' },
                                            { title: 'Old Type', field: 'previousCollectionType' },
                                            { title: 'Changed type', field: 'changedValue' }
                                        ]}
                                        data={reportData.routeWiseData}
                                        options={{
                                            exportButton: false,
                                            showTitle: false,
                                            headerStyle: { textAlign: "left", height: '1%' },
                                            cellStyle: { textAlign: "left" },
                                            columnResizable: false,
                                            actionsColumnIndex: -1
                                        }}
                                    />
                                </Box>
                            
                        <CardContent>
                          <Box border={1} borderColor="#626964" >
                            <Grid container md={6} spacing={2} style={{ marginTop: '1rem' }}></Grid>
                            <Grid container md={6} spacing={2} style={{ marginTop: '1rem', marginBottom: '1rem' }} >

                              <Grid item md={6} xs={12}>
                                <InputLabel><b>Deduction Amendment Bag Count </b></InputLabel>
                              </Grid>
                              <Grid item md={2} xs={12}>
                                    <InputLabel ><b>{":"}</b> </InputLabel>
                              </Grid>
                               <Grid item md={3} xs={12}>
                              <Chip  className={classes.succes}  label={reportData.noOfDeductionBagCount} />
                              </Grid>

                              <Grid item md={6} xs={12}>
                                <InputLabel><b>Leaf Type Amendment Bag Count</b></InputLabel>
                              </Grid>
                              <Grid item md={2} xs={12}>
                                    <InputLabel ><b>{":"}</b> </InputLabel>
                              </Grid>
                              <Grid item md={3} xs={12}>
                              <Chip  className={classes.succes}  label={reportData.noOfLeafTypeCount} />
                              </Grid>

                              <Grid item md={6} xs={12}>
                                <InputLabel><b>Total Bag Count </b></InputLabel>
                              </Grid>
                              <Grid item md={2} xs={12}>
                                    <InputLabel ><b>{":"}</b> </InputLabel>
                              </Grid>
                              <Grid item md={3} xs={12}>
                              <Chip  className={classes.succes}  label={reportData.totBagCount} />
                              </Grid>

                              <Grid item md={6} xs={12}>
                                <InputLabel><b>No of Amended Routes</b></InputLabel>
                              </Grid>
                              <Grid item md={2} xs={12}>
                                    <InputLabel ><b>{":"}</b> </InputLabel>
                              </Grid>
                              <Grid item md={3} xs={12}>
                              <Chip  className={classes.succes}  label={reportData.numberOfAmendedRoutes} />
                              </Grid>

                            </Grid>
                          </Box>
                        </CardContent>
                        </div>
                        </form>


                    </div>

                </div>
            </div>
        </Fragment >
    );
}



